module.exports = __webpack_public_path__ + "media/icons/osoba-prywatna-unactive@3x-107d0d6d.svg";